let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("26UZZ")).then(() => parcelRequire('61Hor'));